// ================================
let freeRingHandle = 'trynow';
let onProductPage = window.location.href.includes('/products/');
let productHandle = $('.product-section').attr('data-product-handle');
let isTryForFreeProduct = productHandle === freeRingHandle;
let lineItemMatchArray = $(`[data-product-handle="${freeRingHandle}"]`);
let tryForFreeTotalQuantity = 0;
// ================================
function productPageAction() {
  if (tryForFreeTotalQuantity < 5) {
    return;
  }
  var message = $('<h5 style="text-align: center">').text(
    'Replica rings are limited to 5 max per order'
  );
  $('[data-add-to-cart]').replaceWith(message);
}
// ================================
function delegateAction() {
  if (onProductPage && !isTryForFreeProduct) {
    return;
  } else if (onProductPage && isTryForFreeProduct) {
    productPageAction();
  }
}
// ================================
function getCartContents() {
  tryForFreeTotalQuantity = 0;
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'json',
    success: function (cartData) {
      let items = cartData.items;

      for (let i = 0; i < items.length; i++) {
        if (items[i].handle === freeRingHandle) {
          tryForFreeTotalQuantity += items[i].quantity;
        }
      }
      delegateAction();
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('Error fetching cart contents:', errorThrown);
    },
  });
}
// ================================
getCartContents();
// ================================

// //  ========= WORKING ON "ON CHANGE EVENT" IN THE CART PAGE SPECIFICALLY
// regardless the event listener for click need to be tied to the
//   = we could jsut select all the minus button and watch them
//  - what happends when the increase the counte what then?
//  - we again would need to check it

// so on the button click of either we need to heck the current count of them

// ASSMING CHANGE:
// if its less than 5 we show plus button
// if its at 5 we hide the corresponding buttons

// for we can still itarate over the main div and thus have access to both button fo rthe specifica replica
//  - from there how do we chose the action to take?

//  - 1 we need to check the count of replica then based on revute number take action
// : ie show or hide buttons

// but how to we add the event listener?
//  - do we have direct acdess ? i think we do to do that
//  - event lisetr directly - then its just the fuction its going to run

// which can we simply selets at the satrat that it dosent matter which we select and which matter that we do select the correct ones?

// to stat the main div if we watched them we would only be watching the ones with teh corresponding product handle ie only the div for the replica line item and nothing else

// that we can also select right of the bat

// ======= UDPATES:
// collection price resovled
// locolization uk routing (send loom have him recreate it)
// max quantity update just about done
// NEXT: finish up max quantity (on change additions)
// ---- THEN => move on to the other items
